export const generateOptions = (recordQuantity) => {
	const options = [];
	for (let i = 1; i < recordQuantity; i++) {
		options.push({ label: i, value: i });
	}
	return options;
};
